import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const usePointsReport = () => useQuery({ queryKey: [`points-report`], queryFn: async () => {
    const callback = await API.get(`/points/report`)
    return callback?.data
}, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 60 * 24})

export default usePointsReport